<template>
    <div class="ecg_root_div">
        <div class="page-header header1">
          <div class="bluebar head_logo"></div>
          <div>{{$t("message")["EcgView.title"]}}&nbsp;&nbsp;&nbsp;&nbsp;{{ data_date }}</div>
          <a-date-picker id="date_picker" @change="ChangeDataDate"></a-date-picker>
        </div>
        <div class="ecg_info">
            <div class="chart_title">
                <p class="ecg_p_text_1">{{avgEcgHeart}}</p>
                <p class="ecg_p_text_2">bpm</p>
                <p class="ecg_p_text_3">10</p>
                <p class="ecg_p_text_2">mm/mv</p>
                <p class="ecg_p_text_1">25</p>
                <p class="ecg_p_text_2">mm/s</p>
            </div>
            <p>{{ecgTime}}</p>
        </div>

        <div class="flex-align-center">
        <div class="ecg_line_chart flex-between flex-align-end" id="ecg_line_chart">
            <img class="ecg_full_screen" src="../../assets/show_in_full_screen.png" @click="ecgDialog"/>
        </div>
        </div>

        <ecg-dialog id="dialog_view" v-model="dialogVisible"
                    title="心电图"
                    :flag="dialogVisible"
                    :ecgTime="ecgTime"
                    :ecgAi="ecgAiResult"
                    :ecgAlertData="ecgAlertData"
                    :qt="avgQt"
                    :qtc="avgQtc"
                    :pr="prIntervals"
                    :qrs="avgQrs"
                    :user="user"
                    :ecgDeviceData="deviceData"
                    v-on:cancel="clickCancel()"
                  >
        </ecg-dialog>
        
        <div id="user_note">
            {{$t("message")["EcgView.note"]}}: {{ecgUserFeel}}
            <a-spin id="loading" v-if="showLoading" size="large" tip="Loading..." />
        </div>

        <div class="ecg_ai_result">
            <div class="ecg_h1_margin">{{$t("message")["EcgView.diagnosis"]}}:</div>
            <div>
            <div class="ai_content_area" v-for="(ecgResult,ecgResultIndex) in ecgAiResult"  :key="ecgResultIndex">
                <div class="ai_content_row1">
                    <div class="ecg_p_text_4">{{ecgResult["detail"]}}</div>
                    <img class="ecg_ai_img" :src="ecg_img"/>
                </div>
                <div class="ai_content_row2">{{ ecgAiResultDes[ecgResult["title"]] }}</div>
            </div>
            </div>
            <div class="ecg_disclaimer">{{$t("message")["EcgView.disclaimer"]}}</div>
        </div>

        <div id="ecg_table_title">
            <div class="bluebar" style="margin-right: 10px; margin-left: 20px"></div>
            <div class="title_text">{{this.titleItem}}</div>
            <div class="right_area">            
                <div class="time_range_title" @click="tabCheck(1)" :style="{ color: tabcolor1 }">{{$t("message")["EcgView.today"]}}</div>
                <div class="graybar"></div>
                <div class="time_range_title" @click="tabCheck(2)" :style="{ color: tabcolor2 }">{{$t("message")["EcgView.sevenday"]}}</div>
                <div class="graybar"></div>
                <div class="time_range_title" @click="tabCheck(3)" :style="{ color: tabcolor3 }">{{$t("message")["EcgView.onemonth"]}}</div>
            </div>
        </div>
        <a-table class="ecg_history_table" :columns="columns" :data-source="ecgData" rowKey="start_time" :pagination="paginationConfig">
            <template slot="ai_result-column" slot-scope="ai_result">
                <div>{{getDescOfAiResult(ai_result)}}</div>
            </template>
        </a-table>
    </div>
</template>

<script>
const moment = require('moment');
let ecgRawData;
// eslint-disable-next-line
import TitleLabel from "../../components/ecg/TitleLabel";
// eslint-disable-next-line
import EcgRadioGroup from "../../components/ecg/EcgRadioGroup.vue"
// eslint-disable-next-line
import EcgListItem from "../../components/ecg/EcgListItem"
// eslint-disable-next-line
import img1 from "../../assets/today_data_logo.png"
// eslint-disable-next-line
import img2 from "../../assets/ecg_item_icon_2x.png"
// eslint-disable-next-line
import { mapGetters, mapMutations } from "vuex";
// eslint-disable-next-line
import Electrocardiogram from "../../graph/Electrocardiogram.js"
// eslint-disable-next-line
import EcgDialog from "../../components/ecg/EcgDialog"

import ECGLv from '../../graph/EcgLv'
import domain from "../../domain";
import request from "../../utils/request";


var map = {};
map['SINUS_HR']="凡起源于窦房结的心律，称为窦性心律。窦性心律属于正常节律";
map['SINUS_ARRHYTHMIA']="窦性心律的起源未变，但节律不整，" +
    "与窦性心动过缓同时存在。较常见的一类心律不齐与呼吸周期有关，称呼吸性窦性心律不齐，多见于青少年";
map['SINUS_TACHYCARDIA']="正常成人窦性心律的频率>100次/分，称为窦性心动过速。常见于运动、精神紧张、发热、<br>" +
    "甲状腺功能亢进、贫血、失血、心肌炎和拟肾上腺素类药物作用等情况。";
map['SINUS_BRADYCARDIA']="窦性心律的频率60次/分时，称为窦性心动过缓。老年人和运动员心律相对较缓。<br>" +
    "颅内压增高、甲状腺功能低下或使用β-受体阻滞剂等可引起窦性心动过缓。窦性心动过缓低于40次/分较少见。";
map['SINUS_ATRIAL_FIBRILLATION']="心房颤动（简称房颤）是最常见的持续性心律失常。" +
    "房颤时心房激动的频率达300～600次/分，心跳频率往往快而且不规则，有时候<br>" +
    "可达100～160次/分，不仅比正常人心跳快得多，而且绝对不整齐，心房失去有效的收缩功能.";

export default {
    props:  ['userData'],
    name: "EcgView",
    data(){
        return{
            data_date:"",
            deviceid:"",
            device_type: 1,
            uid: "",
            subtitle:"",            
            imgPath:img1,
            imgPath2:img2,
            title:this.$t("message")["EcgView.title"],
            ecgTime:"",
            avgEcgHeart:"--",
            ecgUserFeel:"",
            ecgAiResult:[],
            titleItem:this.$t("message")["EcgView.ecgdatalist"],
            currentState:1,
            ecgData:[],
            indexFlag:0,
            ecgItemBgClass:["ecg_list_bg_1","ecg_list_bg_2"],
            ecgClass:["ecg_list_bg_click_1",""],
            dialogVisible:false,
            ecgView:"",
            spp:"",
            cs:"",
            ecgAlertData:[],
            ecgDataAll:[],
            avgQrs:0,
            prIntervals:0,
            avgQt:0,
            avgQtc:0,
            user:"",
            deviceData:"",
            ecgAiResultDes:{},
            loadingdialog: null,
            showLoading: false,
            ecg_img: '',
            columns: [
                {
                    title: this.$t("message")['EcgView.ecgtime'],
                    dataIndex: 'start_time',
                },
                {
                    title: this.$t("message")['EcgView.ai_result'],
                    dataIndex: 'ai_result',
                    scopedSlots: { customRender: "ai_result-column" }
                },
                {
                    title: this.$t("message")['HealthHome.hr'],
                    dataIndex: 'hr',
                },
                {
                    title: this.$t("message")['DeviceList.action'],
                    dataIndex: 'Action',
                    customRender: (text, record, index) => {
                        return (
                        <div>
                            <a-icon type="eye" class="view_icon" />
                            <a href="#" onClick={() => this.showEcgOf(record)}>{ this.$t("message")["DeviceList.viewdata"] }</a>
                        </div>
                        );
                    },
                }
            ],
            paginationConfig: {
                pageSize: 3,
            },
            tabcolor1:'#4385FF',
            tabcolor2:'#949494',
            tabcolor3:'#949494',                     
        }
    },
    computed: {
        ...mapGetters([
            "this.$store.state.ecgItemIndex"
        ])
    },
    mounted(){
        this.ecgTime="-:-"
        this.avgEcgHeart="--"
        this.ecgUserFeel=""
        this.ecgAiResult=[]
        
        this.device_type = sessionStorage.getItem("device_type");
        this.deviceid = sessionStorage.getItem("deviceid");
        if(this.device_type==2){
            this.uid = sessionStorage.getItem("uid");
        }

        this.data_date = this.$route.params.data_date;

        this.subtitle = this.data_date
        this.getEcgDataList(1);
        this.loadEcgView();
    },
    components:{
        TitleLabel,
        EcgRadioGroup,
        EcgListItem,
        EcgDialog,
    },

    methods:{
        async getEcgDataList(index){
            let momentDate = moment(this.data_date);
            let next_date = momentDate.add(1, 'day').format('YYYY-MM-DD')
            if(index===1){
                let reqParams = {
                    device_id: this.deviceid,
                    start_date: this.data_date,
                    end_date: next_date
                };
                let reqUrl = domain.URLS.ecgDataListUrl;
                if(this.device_type == 2){
                    reqParams = {
                        uid: this.uid,
                        start_date: this.data_date,
                        end_date: next_date
                    };
                    reqUrl = domain.URLS.ecgBleDataListUrl;
                }
                let res = await request({
                    url: reqUrl,
                    method: 'GET',
                    params: reqParams
                });

                if(typeof(res.data.Data) === "undefined"){
                    this.ecgData=[];
                    ecgRawData=[];
                    this.avgEcgHeart="--";
                    this.ecgTime="--";
                    this.ecgAiResult=[];
                    this.ecgUserFeel="";
                    this.ecgDataAll=[];
                    this.ecgAlertData=[];
                    this.ecgView.clearAll();
                    return
                }

                for (let i = 0; i <res.data.Data.length ; i++) {
                    if(res.data.Data[i].ai_result==""){
                        res.data.Data[i].ai_result="[\"\"]"
                    }
                }
                this.ecgDataAll=res.data.Data;
            }else if(index===7){
                let back_7_days = momentDate.subtract(7, 'day').format('YYYY-MM-DD')
                let reqParams = {
                    device_id: this.deviceid,
                    start_date: back_7_days,
                    end_date: next_date
                };
                let reqUrl = domain.URLS.ecgDataListUrl;
                if(this.device_type == 2){
                    reqParams = {
                        uid: this.uid,
                        start_date: back_7_days,
                        end_date: next_date
                    };
                    reqUrl = domain.URLS.ecgBleDataListUrl;
                }
                let res = await request({
                    url: reqUrl,
                    method: 'GET',
                    params: reqParams
                });
                if(typeof(res.data.Data) === "undefined"){
                    this.ecgData=[];
                    ecgRawData=[];
                    this.avgEcgHeart="--";
                    this.ecgTime="--";
                    this.ecgAiResult=[];
                    this.ecgUserFeel="";
                    this.ecgDataAll=[];
                    this.ecgAlertData=[];
                    this.ecgRawData=[];
                    this.ecgView.clearAll();
                    return
                }

                this.ecgDataAll=res.data.Data;
                for (let i = 0; i <this.ecgDataAll.length ; i++) {
                    if(this.ecgDataAll[i].ai_result===""){
                        this.ecgDataAll[i].ai_result="[\"\"]"
                    }
                }

            }else if(index===30){
                let back_30_days = momentDate.subtract(30, 'day').format('YYYY-MM-DD')
                let reqParams = {
                    device_id: this.deviceid,
                    start_date: back_30_days,
                    end_date: next_date
                };
                let reqUrl = domain.URLS.ecgDataListUrl;
                if(this.device_type == 2){
                    reqParams = {
                        uid: this.uid,
                        start_date: back_30_days,
                        end_date: next_date
                    };
                    reqUrl = domain.URLS.ecgBleDataListUrl;
                }
                let res = await request({
                    url: reqUrl,
                    method: 'GET',
                    params: reqParams
                });
                if(typeof(res.data.Data) === "undefined"){
                    return
                }
                this.ecgDataAll=res.data.Data;
                for (let i = 0; i <this.ecgDataAll.length ; i++) {
                    if(this.ecgDataAll[i].ai_result===""){
                        this.ecgDataAll[i].ai_result="[\"\"]"
                    }
                }
            }
            this.ecgData = this.ecgDataAll;
            this.numberItem(0);
        },
        translateEcgAiResult(result){
            var params = [];
            
            if(result==="SINUS_HR"){
                params.push({'title':result,"detail":this.$t("message")["EcgView.SINUS.HR"]});
                this.ecg_img=require('../../assets/ecg_ai_normal.png')
            }else if(result==="SINUS_BRADYCARDIA"){
                params.push({'title':result,"detail":this.$t("message")["EcgView.SINUS.BRADYCARDIA"]});
                this.ecg_img=require('../../assets/ecg_ai_abnormal.png')
            }else if(result==="SINUS_TACHYCARDIA"){
                params.push({'title':result,"detail":this.$t("message")["EcgView.SINUS.TACHYCARDIA"]});
                this.ecg_img=require('../../assets/ecg_ai_abnormal.png')
            }else if(result==="SINUS_ARRHYTHMIA"){
                params.push({'title':result,"detail":this.$t("message")["EcgView.SINUS.ARRHYTHMIA"]});
                this.ecg_img=require('../../assets/ecg_ai_abnormal.png')
            }else if(result==="SINUS_ATRIAL_FIBRILLATION"){
                params.push({'title':result,"detail":this.$t("message")["EcgView.SINUS.ATRIAL.FIBRILLATION"]});
                this.ecg_img=require('../../assets/ecg_ai_abnormal.png')
            }else{
                params.push({'title':'NoResult',"detail":this.$t("message")["EcgView.SINUS.NOResult"]});
                this.ecg_img=require('../../assets/ecg_ai_normal.png')
            }
            this.ecgAiResult=params;
        },
        getDescOfAiResult(result){
            let desc = '';
            if(result==="[\"SINUS_HR\"]"){
                desc = this.$t("message")["EcgView.SINUS.HR"];
            }else if(result==="[\"SINUS_BRADYCARDIA\"]"){
                desc = this.$t("message")["EcgView.SINUS.BRADYCARDIA"];
            }else if(result==="[\"SINUS_TACHYCARDIA\"]"){
                desc = this.$t("message")["EcgView.SINUS.TACHYCARDIA"];
            }else if(result==="[\"SINUS_ARRHYTHMIA\"]"){
                desc = this.$t("message")["EcgView.SINUS.ARRHYTHMIA"];
            }else if(result==="[\"SINUS_ATRIAL_FIBRILLATION\"]"){
                desc = this.$t("message")["EcgView.SINUS.ATRIAL.FIBRILLATION"];
            }else{
                desc = this.$t("message")["EcgView.SINUS.NOResult"];
            }
            return desc;
        },
        loadEcgView(){
            this.ecgView = new Electrocardiogram(document.getElementById('ecg_line_chart'));
            this.spp = this.ecgView.getPeriod;
            this.cs = this.ecgView.getCellSize;
        },

        async loadEcgDialog(startTime,direction){
            let reqUrl = domain.URLS.ecgDetailDataUrl;
            let reqParams = {
                device_id: this.deviceid,
                ecg_date: startTime
            };
            if(this.device_type == 2){
                reqUrl = domain.URLS.ecgBleDetailDataUrl;
                reqParams = {
                    uid: this.uid,
                    ecg_date: startTime
                };
            }

            let res = await request({
                url: reqUrl,
                method: 'GET',
                params: reqParams
            });

            if(res.data.ReturnCode != 0){
                return
            }
            let ecgRawDataStart=res.data.Data.FilterResult.EcgList;
            let ecg =this.ecgView;

            if(typeof(ecgRawDataStart) === "undefined"){
                ecgRawData=[];
                this.avgEcgHeart="--";
                this.ecgTime="--";
                this.ecgAiResult=[""];
                this.ecgUserFeel="";
                this.ecgAlertData=[];
                this.ecgRawData=[];
                return
            }

            for (let i = 750; i < ecgRawDataStart.length; i++) {
                let aa= Number(ecgRawDataStart[i]);
                ecgRawDataStart[i]=aa;
                if(direction==-1){
                    ecgRawDataStart[i] = ecgRawDataStart[i]*(-1);
                }
            }

            let str = ecgRawDataStart.join(',');
            this.deviceData=str;
            let thatEcgData=ecgRawDataStart;

            let spp = ecg.getSamplesPerPeriod();
            let cs = ecg.getCellSize();
            if (thatEcgData.length<750 ){
                return;
            }
            let ecgArrayData=[];
            const data=(function rowData() {
                for (let i = 750; i < thatEcgData.length; i++) {
                    var aa= Number(thatEcgData[i]);
                    aa=aa/2000;
                    aa *= cs * 0.01*1600;
                    ecgArrayData[i-750]=aa;
                }
                return ecgArrayData
            })();

            const  params = [];
            for (let i = 0; i < data.length; i++) {
                params.push({"rawdata":data[i]});
            }
            this.ecgAlertData=params;
        },

        async loadEcgData(index,startTime,direction){
            let reqUrl = domain.URLS.ecgDetailDataUrl;
            let reqParams = {
                device_id: this.deviceid,
                ecg_date: startTime
            };
            if(this.device_type == 2){
                reqUrl = domain.URLS.ecgBleDetailDataUrl;
                reqParams = {
                    uid: this.uid,
                    ecg_date: startTime
                };
            }
         
            let res = await request({
                url: reqUrl,
                method: 'GET',
                params: reqParams
            });
            if(res.data.ReturnCode != 0){

                return
            }
            let ecgRawDataStart=res.data.Data.FilterResult.EcgList;
            let ecg =this.ecgView;
            this.ecgAiResultDes=map;

            if(typeof(ecgRawDataStart) === "undefined"){
                ecgRawData=[];
                this.avgEcgHeart="--";
                this.ecgTime="--";
                this.ecgAiResult=[""];
                this.ecgUserFeel="";
                return
            }else {
                setTimeout(() => {
                    if(this.loadingdialog != null){
                        this.loadingdialog.close();
                        this.loadingdialog = null
                    }
                }, 1000);
            }
            for (let i = 750; i < ecgRawDataStart.length; i++) {
                let aa= Number(ecgRawDataStart[i]);
                ecgRawDataStart[i]=aa;
            }

            let thatEcgData=ecgRawDataStart.slice(750,7500);

            let str = thatEcgData.join(',');
            this.translateEcgAiResult(res.data.Data.Result);
            let spp = ecg.getSamplesPerPeriod();
            let cs = ecg.getCellSize();
            if (thatEcgData.length<750 ){
                return;
            }
            let ecgArrayData=[];
            const  data=(function rowData() {

                for (let i = 750; i < thatEcgData.length; i++) {

                    var aa= Number(thatEcgData[i]);
                    aa=aa/2000;
                    aa *= cs * 0.01*1000;
                    ecgArrayData[i-750]=aa;
                }
                return ecgArrayData
            })();
            if(direction==-1){
                for (let i = 0; i < data.length; i++){
                    data[i] = data[i]*(-1);
                }
            }
            const  params = [];
            for (let i = 0; i < data.length; i++) {
                params.push({"rawdata":data[i]});
            }
            ecgRawData = params;

            ecg.setEcgRawData(ecgRawData);

            ecg.drawCurve(ecgRawData.slice(0, spp),true);
            if(typeof(this.timer) === "undefined"){
                this.timer=null;
                window.clearInterval(this.timer);
                this.timer= window.setInterval(function() {
                    if (ecgRawData.length) {
                        ecg.drawCurve(ecgRawData.slice(0, spp),false);
                        ecgRawData.shift();
                        ecg.setEcgRawData(ecgRawData);
                    } else {
                        window.clearInterval(this.timer);
                    }
                },25);
            }
            this.ecgAlertData=params;
        },
        numberItem(index){
            //show loading... since data load time is long
            this.showLoading = true;
            this.setIndex(index);
            this.indexFlag=index;
            this.avgEcgHeart=this.ecgData[index].hr===0?"--":this.ecgData[index].hr;
            this.ecgTime=this.ecgData[index].start_time;
            if(this.ecgData[index].ai_result==null || this.ecgData[index].ai_result==""){
                this.ecgAiResult=[""];
            }else {
                try{
                    this.ecgAiResult=JSON.parse(this.ecgData[index].ai_result);
                }
                catch(error){
                    console.log(error);
                    this.ecgAiResult=[""];
                }
            }

            this.ecgUserFeel=this.ecgData[index].note;
            this.loadEcgData(index,this.ecgData[index].start_time,this.ecgData[index].direction);
            this.loadEcgDialog(this.ecgData[index].start_time,this.ecgData[index].direction);
            //if data load still not finish, close loading... after 10 seconds
            setTimeout(() => {
                this.showLoading = false;
            }, 10000);
        },
        clickCancel(){

        },
        ecgDialog(){
            this.dialogVisible = true
        },
        tabCheck(tabIndex){
            this.currentState = tabIndex;
            this.ecgDataAll=[];
            this.tabcolor1 = '#949494';
            this.tabcolor2 = '#949494';
            this.tabcolor3 = '#949494';
            if(this.currentState==1){
                this.tabcolor1 = '#4385FF';
                this.getEcgDataList(1);
            }else if(this.currentState==2){
                this.tabcolor2 = '#4385FF';
                this.getEcgDataList(7);
            }else if(this.currentState==3){
                this.tabcolor3 = '#4385FF';
                this.getEcgDataList(30);
            }
        },
        showEcgOf(record){
            for (let i = 0; i < this.ecgData.length; i++) {
                if(record["start_time"] == this.ecgData[i]["start_time"]){
                    this.numberItem(i);
                    break;
                }
            }
        },
        ChangeDataDate(val){
            this.data_date = val.format('YYYY-MM-DD');
            this.subtitle = this.data_date
            this.ecgAiResult=[]
            this.getEcgDataList(1);
        },
        ...mapMutations({
            setIndex:"ecg/SET_ECG_ITEM_INDEX",
        })
    },
}
</script>

<style lang="less" scoped>
@import "../style/base.less";

.ecg_root_div {
  padding-bottom: 10px;
  position: relative;
  left: 0px;
  border: 1px solid white;
}

.page-header {
  height: 50px;
  font-size: 16px;
  color: #292929;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: center;
}

.header1 {
  justify-content: space-around;
}

.bluebar {
  width: 4px;
  height: 13px;
  background-color: #2284FF;
}

.head_logo {
  margin-right: 10px;
}

#date_picker {
  margin-left: auto;
}

canvas {
      border: 1px solid #FFBFBF;
    }

.ecg_line_chart{
    position: relative;
    width:100%;
    height: 150px;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #fff;
    border: none;
}

.ecg_ai_result{
    height: 140px;
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #EBEEEE;
    display: flex;
    flex-direction: column;
}

.ecg_layout_top1{
    margin-top: .1rem;
    margin-bottom: .1rem;
}

.ecg_p_text_1{
    padding-left: .5rem;
    color: #292929;
    font-weight: bold;
    font-size: 16px;
}
.ecg_p_text_2{
    padding-left: .5rem;
    color: #727272;
    font-size: 14px;
}
.ecg_p_text_3{
    margin-left: 2rem;
    color: #292929;
    font-weight: bold;
    font-size: 16px;
}

.ecg_p_text_4{
    margin-left: 20px;
    margin-right: 5px;
    color: #505050;
    font-size: 13px;
}
.ecg_h1_margin{
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: bold;
    color: #454545;
}

.ecg_disclaimer{
    margin-left: 20px;
    margin-top: 1rem;
    color: #999999 ;
    margin-bottom: 5px;
    font-size: 12px;
}

.ecg_div_ai_result{
    display: flex;
    flex-direction: row;
}
.ecg_base_rem{
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.ecg_tab{
    padding-top: .3rem;
    padding-bottom: .4rem;
    padding-left: .2rem;
    padding-right: .2rem;
    fill: #52BA9F
}
.ecg_list_bg_1{
    background-color: #EBEEEE;
}

.ecg_list_bg_2{
    background-color: #fff;
}

.ecg_list_bg_click_1{
    color: #F65D5D;
}

.ecg_pagination{
    color: #52BA9F;
}

.ecg_full_screen{
    position: absolute;
    left:  94%;right:0;
    top:  80%;bottom:0;
    width: 20px;
    height: 20px;
}

</style>

<style lang="scss" scoped>
#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 250px;
}

#user_note {
    background-color: #FFF9F5;
    height: 40px;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    color: #FF9B52;
    font-size: 12px;
    display: flex;
    align-items: center;
    padding-left: 20px;
}

.ecg_info {
    margin-left: 20px;
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
}

.chart_title {
    display: flex;
    align-items: center;
}

.ecg_ai_img {
    width: 14px;
    height: 14px;
}

.ai_result_title {
    border: 1px solid;
}

.ai_content_area {
    
}

.ai_content_row1 {
    display: flex;
    align-items: center;
    color: #505050;
    font-size: 14px;
}

.ai_content_row2 {
    margin-top: 5px;
    margin-left: 20px;
    color: #505050;
    font-size: 12px;
    height: 40px;
}

#ecg_table_title {
    display: flex;
    align-items: center;
    margin-top: 20px;
} 

.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.title_text {
    color: #292929;
    font-size: 16px;
    font-weight: bold;
}

.graybar {
    width: 2px;
    height: 11px;
    background-color: #C2C2C2;
}

.time_range_title {
    width: 80px;
    height: 18px;
    font-size: 12px;
    text-align: center;
}

.right_area {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.ecg_history_table {
    margin-left: 20px;
    margin-right: 20px;
}
</style>
